export const comments_3750242 = {"data":{"data":[],"links":{}}}